<template>
	<div class="thanks-page">
		<div class="page-content">
			<div class="text-center">
				<h2 class="primary-hd">
					Thank you, {{ name }} !
				</h2>
				<p class="thanks-text">
					Our calculator was unable to find a valid quote. You will receive a call in the <b>next 5 minutes</b> from our movers to complete your request.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Thanks',
	data: function() {
		return {
			name: '',
			step: 9,
		};
	},
	created: function() {
		this.checkForQuoteData();
	},
	mounted: function() {
		this.$store.dispatch('progress/updateProgress', this.step);

		this.$session.destroy();
	},
	beforeRouteLeave: function(to, from, next) {
		next(false);
	},
	methods: {
		checkForQuoteData: function() {
			const quote = this.$store.state.quote;

			this.name = quote.firstName;
		},
	},
};
</script>

<style lang="scss">
.thanks-page .primary-hd {
	font-size: 1.7rem;
}

.thanks-text {
	font-size: 1.2rem;
}
</style>
